import { APIS, getApi, postApi } from "../../utils/api-utils";

export const INCEPTION_DUPLICATE_USER_CODE = "INCEPTION_DUPLICATE_USER";

export const syncInceptionUsers = async () => {
    return await postApi(APIS.INTEGRATION_API, "/inception/sync-users", {});
};

export const getInceptionPermissionGroups = async (buildingId: string, tenantId: string) => {
    return await getApi(APIS.INTEGRATION_API, `/inception/permission-groups/${buildingId}/${tenantId}`);
};

export const getInceptionUserPermissionGroups = async (buildingId: string, tenantId: string, userId: string) => {
    return await getApi(APIS.USER_API, `/user/inception/permission-groups/${buildingId}/${tenantId}/${userId}`);
};

export const isInceptionDuplicateUserError = (e: any) => {
    return e?.response?.data?.code === INCEPTION_DUPLICATE_USER_CODE;
};

export const getInceptionDuplicateUserErrorData = (e: any) => {
    if (!isInceptionDuplicateUserError(e)) {
        return null;
    }

    const duplicateUsers = Array.isArray(e?.response?.data?.duplicateUsers)
        ? e.response.data.duplicateUsers
        : [];
    const linkCandidate = e?.response?.data?.linkCandidate || duplicateUsers[0] || null;

    return {
        message: e?.response?.data?.message || "A similar user already exists in the Inception server.",
        duplicateUsers,
        linkCandidate
    };
};
